// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseNotaryFactory instead of class inheritance

import { createBaseNotary, type IBaseNotary } from "../BaseNotaryFactory";
import type { DocumentsNotaryInstance } from "./helpers/documentsNotaryInstanceHelpers";
import { createDocumentsNotaryInstance } from "./helpers/documentsNotaryInstanceHelpers";
import { createApiFactory } from "@Front/Api/helpers/BaseApiFactoryGenerator";

const factory = createApiFactory<IBaseNotary, DocumentsNotaryInstance>({
	name: "DocumentsNotary",
	createBase: createBaseNotary,
	createInstance: createDocumentsNotaryInstance,
});

export function getDocumentsNotaryInstance(): DocumentsNotaryInstance {
	return factory.getInstance();
}
